import React from 'react';

export function UdvegaIcon({ size = 32, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <linearGradient id="udvega-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="50%" stopColor="#0D9488" />
          <stop offset="100%" stopColor="#06B6D4" />
        </linearGradient>
        <linearGradient id="udvega-line" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#0D9488" />
          <stop offset="100%" stopColor="#22D3EE" />
        </linearGradient>
      </defs>
      {/* U Shape */}
      <path
        d="M8 8 L8 28 C8 37.9 16.1 46 26 46 C35.4 46 40 37.9 40 28 L40 8"
        stroke="url(#udvega-grad)"
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
      {/* Pixel blocks (top-left, data/AI indicator) */}
      <rect x="5" y="4" width="4" height="4" rx="1" fill="#7C3AED" opacity="0.7" />
      <rect x="10" y="4" width="4" height="4" rx="1" fill="#6D28D9" opacity="0.5" />
      <rect x="5" y="9" width="4" height="4" rx="1" fill="#8B5CF6" opacity="0.4" />
      {/* Upward trend line inside U */}
      <path
        d="M14 36 L20 28 L28 32 L36 16"
        stroke="url(#udvega-line)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Data nodes */}
      <circle cx="20" cy="28" r="3" fill="#0D9488" />
      <circle cx="28" cy="32" r="2.5" fill="#14B8A6" />
      <circle cx="36" cy="16" r="3.5" fill="#06B6D4" />
      {/* Glow on top node */}
      <circle cx="36" cy="16" r="6" fill="#06B6D4" opacity="0.15" />
    </svg>
  );
}

export function UdvegaLogo({ dark = false, size = 'md' }) {
  const textSize = size === 'lg' ? 'text-2xl' : size === 'sm' ? 'text-lg' : 'text-xl';
  const iconSize = size === 'lg' ? 40 : size === 'sm' ? 24 : 32;
  const textColor = dark ? 'text-white' : 'text-slate-800';
  const taglineColor = dark ? 'text-slate-400' : 'text-slate-500';

  return (
    <div className="flex items-center gap-2.5">
      <UdvegaIcon size={iconSize} />
      <div className="flex flex-col">
        <span className={`font-heading font-semibold ${textSize} ${textColor} leading-tight`}>
          Udvega
        </span>
        {size === 'lg' && (
          <span className={`text-[10px] tracking-wider uppercase ${taglineColor}`}>
            Predicting Burnout. Preserving Sanity.
          </span>
        )}
      </div>
    </div>
  );
}
